var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "full-width-background" }, [
    _c("div", { staticClass: "container" }, [
      _c("p", { staticClass: "collection-breadcrumbs" }, [
        _c("a", { attrs: { href: "/" } }, [_vm._v("Home")]),
        _c("span", { staticClass: "collection-breadcrumbs__divider" }, [
          _vm._v("/")
        ]),
        _c("span", [_vm._v(_vm._s(_vm.collectionTitle))])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }